import React from 'react'
import PropTypes from 'propTypes'
import styles from './styles'

const DropdownButton = ({ onClick, label, active }) => (
  <li role="menuitem">
    <button type="button" onClick={onClick} className={styles.button} disabled={active}>
      {label}
    </button>
  </li>
)

DropdownButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
}

export default DropdownButton
